import { BOOLEAN, NUMBER, NUMBER_CSV, STRING, STRING_CSV } from './utils';
import { maybe } from 'true-myth';

export const getNumberConfig = (name: string, defaultVal: number) =>
  NUMBER()
    .andThen((number) => maybe.of(number[name]))
    .unwrapOr(defaultVal);

export const getStringConfig = (name: string, defaultVal: string) =>
  STRING()
    .andThen((string) => maybe.of(string[name]))
    .unwrapOr(defaultVal);

export const getBooleanConfig = (name: string, defaultVal: boolean) =>
  BOOLEAN()
    .andThen((boolean) => maybe.of(boolean[name]))
    .unwrapOr(defaultVal);

export const getStringListConfig = (name: string, defaultVal: Array<string>) =>
  STRING_CSV()
    .andThen((stringCsv) => maybe.of(stringCsv[name]))
    .map((csv) => csv.split(','))
    .unwrapOr(defaultVal);

export const getNumberListConfig = (name: string, defaultVal: Array<number>) =>
  NUMBER_CSV()
    .andThen((numberCsv) => maybe.of(numberCsv[name]))
    .map((csv) => csv.split(',').map(Number))
    .unwrapOr(defaultVal);
